import Image from 'next/image';
import { Heading, HeadingType, Paragraph } from '../../Typography';

interface CardsTaxesProps {
  cardData: {
    heading: string;
    icon: string;
    description: string;
  };
}

const CardsSecure = ({ cardData }: CardsTaxesProps): JSX.Element => {
  const { heading, icon, description } = cardData;
  return (
    <div className="w-11/12 pt-5 pr-5 sm:pb-0 sm:w-full sm:pr-0">
      <div className="h-12">
        <Image src={icon} width="45" height="45" alt="icon" />
      </div>
      <div className="pt-6 break-words sm:pt-6">
        <Heading
          content={heading}
          variant={HeadingType.h5}
          className="text-s-24 mb-4 sm:text-s-20"
        />
        <Paragraph className="sm:mb-1" bottomMargin={false}>
          {description}
        </Paragraph>
      </div>
    </div>
  );
};

export { CardsSecure };
